/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'jquery',
	'text!./SelectionEdges.html'
], function(Class, $, Template) {

	const SelectionAction = Class.extend({

		newSelection: function(nodes) {
			if (this.selectedNodes) {
				this._removeBorders(this.selectedNodes);
			}

			// Maintain all the selected nodes.
			this.selectedNodes = nodes;

			// Only add borders to the new nodes.
			this._addBorders(nodes);
		},

		// Private

		_removeBorders: function(nodes) {
			$(nodes)
				.removeClass('resize')
				.children('.resizeEdge')
				.remove();
		},

		_addBorders: function(nodes) {
			$(nodes).append(Template);
		}

	});

	return SelectionAction;

});
